module.exports = __webpack_public_path__ + "static/img/login-icon.645eb5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-icon.png
// module id = 0pVo
// module chunks = 1